import React, { useContext, useState, useEffect } from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { Title2, Title5 } from '@hz-design-system/web-ui';

import EnvironmentContext from '../../contexts/EnvironmentContext';
import getStaticImageUrl from '../../utils/getStaticImageUrl';

import Classes from './BundleSocialProof.scss';

const BundleSocialProof = () => {
  const { tenant, staticBaseUrl } = useContext(EnvironmentContext);
  const [images, setImages] = useState<string[]>([]);

  const fetchImages = () =>
    Promise.all([
      import(`../../../images/bundle-page/${tenant}/social-proof-0.jpg`),
      import(`../../../images/bundle-page/${tenant}/social-proof-1.jpg`),
      import(`../../../images/bundle-page/${tenant}/social-proof-2.jpg`),
    ])
      .then((loadedImages) => loadedImages.map((image) => image.default))
      .then((imagePaths) => setImages(imagePaths));

  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <div className={Classes.root}>
      <Title2>
        <Trans tagName="span" i18nKey="purchaseBundle.socialProof.title" />
      </Title2>
      <div className={Classes.items}>
        {[0, 1, 2].map((i) => (
          <div className={Classes.item} key={i}>
            <div className={Classes.itemImage}>
              <img src={getStaticImageUrl(staticBaseUrl, images[i])} alt="" />
            </div>
            <div className={Classes.itemContent}>
              <Title5>
                <Trans tagName="span" className={Classes.name} i18nKey={`purchaseBundle.socialProof.${i}.sellerName`} />
                <Trans
                  tagName="span"
                  className={Classes.businessName}
                  i18nKey={`purchaseBundle.socialProof.${i}.sellerBusinessName`}
                />
              </Title5>
              <Trans className={Classes.quote} tagName="p" i18nKey={`purchaseBundle.socialProof.${i}.sellerQuote`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BundleSocialProof;
